import { GinStepItemTargetUsers, GinStepTargetUsers, ItemConditionType, } from '@hellodarwin/core/lib/features/entities/gin-step-entities';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import dayjs from 'dayjs';
import { formatDollarValue } from '../../shared/utils';
export const useGinStepUtils = () => {
    const { t } = useTranslations();
    const getConditionTypeLabel = (conditionType, isTargetingDate) => {
        if (isTargetingDate) {
            switch (conditionType) {
                case ItemConditionType.Equals:
                    return t('gin_steps|date_on');
                case ItemConditionType.NotEquals:
                    return t('gin_steps|date_not_on');
                case ItemConditionType.Greater:
                    return t('gin_steps|date_after');
                case ItemConditionType.Lower:
                    return t('gin_steps|date_before');
                case ItemConditionType.Empty:
                case ItemConditionType.Filled:
                case ItemConditionType.Contains:
                case ItemConditionType.Required:
                case ItemConditionType.None:
                    break;
            }
        }
        return t(`gin_steps|${String(conditionType).replace(/\s+/g, '_').toLowerCase()}`);
    };
    return {
        getConditionTypeLabel,
    };
};
export const optionFromRawPropertyValue = (propertyColumn, propertyType, rawValue, selectedLocale, options) => {
    if (!propertyColumn || !rawValue) {
        return undefined;
    }
    switch (propertyColumn) {
        case 'exact_annual_revenue': {
            const numValue = Number(rawValue);
            if (!isNaN(numValue) && numValue === 0) {
                return undefined;
            }
            return {
                label: !isNaN(numValue)
                    ? formatDollarValue(numValue, selectedLocale, true, true)
                    : rawValue,
                value: !isNaN(numValue) ? numValue : rawValue,
            };
        }
        case 'program_targeted_amount': {
            const numValue = Number(rawValue);
            if (propertyType === 'number' && !isNaN(numValue)) {
                return {
                    label: formatDollarValue(numValue, selectedLocale, true, true),
                    value: numValue,
                };
            }
            return { label: rawValue, value: rawValue };
        }
        case 'founded_at':
        case 'program_requested_at': {
            const date = new Date(rawValue);
            if (!isNaN(date.getTime())) {
                return {
                    label: dayjs(date).format('YYYY-MM-DD'),
                    value: date,
                };
            }
            return { label: rawValue, value: rawValue };
        }
        case 'naics_code':
        case 'industry_sector':
        case 'industry_subsector': {
            const values = rawValue.split(',').map((v) => v.trim());
            return {
                label: values.flatMap((v) => { var _a, _b; return (_b = (_a = options === null || options === void 0 ? void 0 : options.find((o) => o.value === v)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ''; }),
                value: values,
            };
        }
        case 'business_number':
        case 'city':
        case 'province':
        case 'size':
        default:
            return { label: rawValue, value: rawValue };
    }
};
export const getStepTargetUsersFromView = (view) => {
    switch (view) {
        case 'admin_fr':
        case 'admin_en':
            return GinStepTargetUsers.Admins;
        case 'client_fr':
        case 'client_en':
            return GinStepTargetUsers.Clients;
    }
};
export const getStepItemTargetUsersFromView = (view) => {
    switch (view) {
        case 'admin_fr':
        case 'admin_en':
            return GinStepItemTargetUsers.Admins;
        case 'client_fr':
        case 'client_en':
            return GinStepItemTargetUsers.Clients;
    }
};
